<template>
    <div class="grid grid-cols-4 gap-8">
        <div class="-mt-2">
            <button @click="selectedTabName = tab.name" v-for="tab in tabs" :key="tab.name"
                :class="[tab.name == selectedTabName ? 'bg-primary-500 text-contrast-500' : '', 'py-[8px] px-[20px] text-left font-medium rounded-xl text-xl h-[56px] shrink mt-2 w-full']">{{
                tab.label }}</button>
        </div>
        <div class="bg-white rounded-xl col-span-3 h-full py-[15px] px-[22px] lg:h-[454px] overflow-y-scroll">
            <div v-if="selectedTabName == 'standards'" class="mb-8">
                <!-- New-model standards (cutover): grouped jurisdiction -> framework -> standards -->
                <div v-if="standardsGrouped.length">
                    <div v-for="jur in standardsGrouped" :key="jur.jurisdiction_code" class="mb-6">
                        <h3 class="font-semibold">{{ jur.jurisdiction }}</h3>
                        <div v-for="fw in jur.frameworks" :key="fw.framework" class="mt-2 ml-2">
                            <p class="text-sm text-gray-500">{{ fw.framework }}</p>
                            <ul class="ml-2">
                                <li v-for="std in fw.standards" :key="std.code" class="mt-2">
                                    <span class="font-mono font-semibold">{{ std.code }}</span>
                                    <span v-if="std.description" class="ml-2">{{ std.description }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- Legacy standards trees -->
                <template v-else>
                    <div v-if="!Array.isArray(primaryStandardsNamesTree)">
                        <h3 v-if="resource.is_internal_resource" class="font-semibold">Primary Standards</h3>
                        <ul class="-mt-6 trix">
                            <li v-for="performances, standardName in primaryStandardsNamesTree" :key="standardName" class="mt-8">
                                <span class="font-semibold">{{ standardName }}</span>
                                <ul class="-mt-6">
                                    <li v-for="codes, performanceName in performances" :key="performanceName" class="mt-8">
                                        <span>{{ performanceName }}</span>
                                        <ul class="-mt-2">
                                            <li v-for="code in codes" :key="code" class="mt-4">
                                                <span>{{ code }}</span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div v-if="!Array.isArray(supportingStandardsNamesTree)" class="mb-8">
                        <h3 v-if="resource.is_internal_resource" class="font-semibold">Supporting Standards</h3>
                        <ul class="-mt-6 trix">
                            <li v-for="performances, standardName in supportingStandardsNamesTree" :key="standardName" class="mt-8">
                                <span class="font-semibold">{{ standardName }}</span>
                                <ul class="-mt-6">
                                    <li v-for="codes, performanceName in performances" :key="performanceName" class="mt-8">
                                        <span>{{ performanceName }}</span>
                                        <ul class="-mt-2">
                                            <li v-for="code in codes" :key="code" class="mt-4">
                                                <span>{{ code }}</span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { usePage } from '@inertiajs/vue3'

const tabs = [
    {
        label: 'Standards',
        name: 'standards'
    }
];
export default {
    props: {
        resource: Object
    },
    components: {

    },
    data() {
        return {
            selectedTabName: 'standards'
        }
    },
    computed: {
        selectedTab() {
            let tabs = this.tabs.filter(tab => tab.name == this.selectedTabName);
            if (tabs.length)
                return tabs[0]
            return null;
        },
        // New-model standards (present after the content_entities cutover).
        standardsGrouped() {
            return this.resource.standards_grouped ?? []
        },
        primaryStandardsNamesTree() {
            return this.resource.standards_names_trees?.[this.tenantSlug]?.['primary'] ?? {}
        },
        supportingStandardsNamesTree() {
            return this.resource.standards_names_trees?.[this.tenantSlug]?.['supporting'] ?? {}
        },
        standardsTree() {

        }
    },
    setup() {
        const tenantSlug = usePage().props.tenantSlug

        return {
            tabs,
            tenantSlug
        }
    }
}
</script>
